import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import AccordionBtn from './AccordionBtn';
import AccordionContent from './AccordionContent';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as enviromentHelper from '../../../helpers/environmentHelper';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class AccordionItem extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            topPos: 35,
            mobileTopPos: 15,
        };
        this.setClass = this.setClass.bind(this);
        this.setScrollPosition = this.setScrollPosition.bind(this);
    }

    componentDidMount() {
        this.setClass();
    }

    componentWillReceiveProps(nextProps) {

    }

    setClass() {
        let className = "";

        if (this.props.screen.screen_id === this.props.activeScreenId) {
            className += "open ";
        }else{
            className += "closed ";
        }

        return className;
    }

    setScrollPosition(){
        let env = enviromentHelper.getEnvironment();
        let item = this.refs[`accordion_item_${this.props.screen.screen_id}`];
        if (this.props.screen.screen_id === this.props.activeScreenId){

            if(env.window.size === "xs"){
                this.props.biteCallbacks.scrollTo(item.offsetTop -  this.state.mobileTopPos);
            }else{
                this.props.biteCallbacks.scrollTo(item.offsetTop -  this.state.topPos);
            }

        }else if(this.props.activeScreenId === "0"){
            if(env.window.size === "xs"){
                this.props.biteCallbacks.scrollTo(this.state.mobileTopPos);
            }else {
                this.props.biteCallbacks.scrollTo(this.state.topPos);
            }
        }
    }


    render() {
        return (
            <div className={`accordion-item ${this.setClass()}`} ref={`accordion_item_${this.props.screen.screen_id}`}>
                <div className={`accordion-item-list`}>
                    <AccordionBtn parentScreen={this.props.parentScreen} screen={this.props.screen} activeScreenId={this.props.activeScreenId} enabledScreens={this.props.enabledScreens} completeScreens={this.props.completeScreens} biteCallbacks={this.props.biteCallbacks} isAnimating={this.props.isAnimating}/>
                    <AccordionContent parentScreen={this.props.parentScreen} screen={this.props.screen} activeScreenId={this.props.activeScreenId} enabledScreens={this.props.enabledScreens} completeScreens={this.props.completeScreens} biteCallbacks={this.props.biteCallbacks} toggleAllItems={this.props.toggleAllItems} setScrollPosition={this.setScrollPosition}/>
                </div>
            </div>
        );

    }
}

AccordionItem.propTypes = {
    parentScreen: PropTypes.object.isRequired,
    screen: PropTypes.object.isRequired,
    activeScreenId: PropTypes.number.isRequired,
    enabledScreens: PropTypes.array.isRequired,
    completeScreens: PropTypes.array.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    toggleAllItems: PropTypes.bool.isRequired,
    isAnimating: PropTypes.bool.isRequired,
    contentData: PropTypes.object,
    trackingData: PropTypes.object,
    actions: PropTypes.object
};

AccordionItem.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        contentData: state.contentData,
        trackingData: state.trackingData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AccordionItem);



/** WEBPACK FOOTER **
 ** ./src/components/screens/accordionScreen/AccordionItem.js
 **/